import type { SVGProps } from 'react';
import { Ref, forwardRef } from 'react';
const SvgPasswordField = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width={16} height={16} ref={ref} {...props}>
    <rect width={31} height={23} x={0.5} y={4.5} fill="#FDF4DC" stroke="#FAE7B9" rx={2.5} />
    <path
      fill="#D9822F"
      d="M21 13h-2v-1.5a3 3 0 0 0-6 0V13h-2a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-7a1 1 0 0 0-1-1m-5 5.25a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5M18 13h-4v-1.5a2 2 0 0 1 4 0z"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgPasswordField);
export default ForwardRef;
